import { Exclude, Expose, Type } from 'class-transformer';
import { IsISO8601, ValidateNested } from 'class-validator';
import { BaseModel } from '@core/data-access';
import { FlattenObject, MyInfoAddress } from '../util';
import { MyInfoAddressNonSG, MyInfoAddressSG } from './address.model';
import { HDBOwnership } from './hdb-ownership.model';
import { CPFHousingWithdrawal } from './cpf-housing-withdrawal.model';
import {
  AcademicQualificationBase,
  ChildrenBirthRecordBase,
  CPFBalanceBase,
  CPFContributionHistoryBase,
  CPFEmployerHistoryBase,
  DrivingLicenceBase,
  GSTVoucherBase,
  HouseHoldIncomeBase,
  MerdekaGenerationBase,
  MobileNumberBase,
  NoticeOfAssessmentBasicBase,
  NoticeOfAssessmentFullBase,
  NoticeOfAssessmentHistoryBasicBase,
  NoticeOfAssessmentHistoryFullBase,
  SilverSupportBase,
  ValueCodeDescBase,
  Vehicle,
} from '../type';

@Exclude()
export class MyinfoModel extends BaseModel {
  @Expose()
  @FlattenObject('value')
  name!: string;

  @Expose()
  @FlattenObject('value')
  aliasname?: string;

  @Expose()
  @FlattenObject('value')
  hanyupinyinname?: string;

  @Expose()
  @FlattenObject('value')
  hanyupinyinaliasname?: string;

  @Expose()
  @FlattenObject('value')
  marriedname?: string;

  @Expose()
  @FlattenObject('value')
  dob?: string;

  @Expose()
  @FlattenObject('code')
  sex?: string;

  @Expose()
  @FlattenObject('code')
  race?: string;

  @Expose()
  @FlattenObject('code')
  secondaryrace?: string;

  @Expose()
  @FlattenObject('code')
  dialect?: string;

  @Expose()
  @FlattenObject('value')
  uinfin?: string;

  @Expose()
  @FlattenObject('code')
  nationality?: string;

  @Expose()
  @FlattenObject('code')
  birthcountry?: string;

  @Expose()
  @FlattenObject('code')
  residentialstatus?: string;

  @Expose()
  @FlattenObject('value')
  passportnumber?: string;

  @Expose()
  @FlattenObject('value')
  @IsISO8601()
  passportexpirydate?: string;

  @Expose()
  mobileno?: MobileNumberBase;

  @Expose()
  homeno?: MobileNumberBase;

  @Expose()
  @MyInfoAddress()
  @ValidateNested()
  regadd?: MyInfoAddressSG | MyInfoAddressNonSG;

  @Expose()
  @MyInfoAddress()
  @ValidateNested()
  mailadd?: MyInfoAddressSG | MyInfoAddressNonSG;

  @Expose()
  @MyInfoAddress()
  @ValidateNested()
  billadd?: MyInfoAddressSG | MyInfoAddressNonSG;

  @Expose()
  @FlattenObject('value')
  email?: string;

  @Expose()
  cpfcontributions?: CPFContributionHistoryBase;

  @Expose()
  noahistory?: NoticeOfAssessmentHistoryFullBase;

  @Expose()
  @FlattenObject('value')
  ownerprivate?: boolean | string;

  @Expose()
  @FlattenObject('code')
  marital?: string;

  @Expose()
  @Type(() => HDBOwnership)
  @ValidateNested({ each: true })
  hdbownership?: HDBOwnership[];

  @Expose()
  @FlattenObject('value')
  partialuinfin?: string;

  @Expose()
  @FlattenObject('code')
  housingtype?: string;

  @Expose()
  @FlattenObject('code')
  hdbtype?: string;

  @Expose()
  @FlattenObject('value')
  marriagecertno?: string;

  @Expose()
  @FlattenObject('code')
  countryofmarriage?: string;

  @Expose()
  @FlattenObject('value')
  @IsISO8601()
  marriagedate?: string;

  @Expose()
  @FlattenObject('value')
  @IsISO8601()
  divorcedate?: string;

  @Expose()
  childrenbirthrecords?: ChildrenBirthRecordBase[];

  @Expose()
  sponsoredchildrenrecords?: ChildrenBirthRecordBase[];

  @Expose()
  schoolname?: ValueCodeDescBase<string>;

  @Expose()
  @FlattenObject('code')
  edulevel?: string;

  @Expose()
  @FlattenObject('code')
  passtype?: string;

  @Expose()
  @FlattenObject('value')
  gradyear?: string;

  @Expose()
  @FlattenObject('value')
  occupation?: string;

  @Expose()
  @FlattenObject('value')
  employment?: string;

  @Expose()
  @FlattenObject('value')
  passstatus?: string;

  @Expose()
  @FlattenObject('value')
  @IsISO8601()
  passexpirydate?: string;

  @Expose()
  @FlattenObject('value')
  employmentsector?: string;

  @Expose()
  householdincome?: HouseHoldIncomeBase;

  @Expose()
  vehicles?: Vehicle[];

  @Expose()
  drivinglicence?: DrivingLicenceBase;

  @Expose()
  academicqualifications?: AcademicQualificationBase;

  @Expose()
  merdekagen?: MerdekaGenerationBase;

  @Expose()
  silversupport?: SilverSupportBase;

  @Expose()
  gstvoucher?: GSTVoucherBase;

  @Expose({ name: 'noa-basic' })
  noaBasic?: NoticeOfAssessmentBasicBase;

  @Expose()
  noa?: NoticeOfAssessmentFullBase;

  @Expose({ name: 'noahistory-basic' })
  noahistoryBasic?: NoticeOfAssessmentHistoryBasicBase;

  @Expose()
  cpfemployers?: CPFEmployerHistoryBase;

  @Expose()
  cpfbalances?: CPFBalanceBase;

  @Expose()
  @Type(() => CPFHousingWithdrawal)
  @ValidateNested()
  cpfhousingwithdrawal?: CPFHousingWithdrawal;
}
